import { Stack, Typography } from '@mui/material';

const SplitNumber = ({
	number,
	isCost,
	isOverlayWidget,
	fontSize,
	fontWeight,
	sameDecimalSize = false,
	color
}: {
	number: number | string;
	isCost?: boolean;
	isOverlayWidget?: boolean;
	fontSize?: any;
	fontWeight?: any;
	sameDecimalSize?: boolean;
	color?: string;
}) => {
	const [integerPart, decimalPart] = number.toString().split('.');

	return (
		<Stack direction="row" alignItems="baseline">
			<Typography
				variant={isOverlayWidget ? 'overlayWidgetValue' : 'widgetValue'}
				sx={{
					fontSize: fontSize ?? { xs: '38px', sm: '50px', md: '60px' },
					...(fontWeight && { fontWeight }),
					...(color && { color })
				}}
			>{`${
				isCost ? '$' : ''
			}${integerPart}`}</Typography>
			{decimalPart && (
				<Typography
					variant={
						sameDecimalSize
							? (isOverlayWidget ? 'overlayWidgetValue' : 'widgetValue')
							: (isOverlayWidget ? 'overlayWidgetUnit' : 'widgetUnit')
					}
					m={0}
					sx={{
						fontSize: sameDecimalSize
							? (fontSize ?? { xs: '38px', sm: '50px', md: '60px' })
							: (fontSize ?? { xs: '14px', sm: '20px', md: '26px' }),
						...(fontWeight && { fontWeight }),
						...(color && { color })
					}}
				>{`.${decimalPart}`}</Typography>
			)}
		</Stack>
	);
};

export default SplitNumber;
